(function() {
    'use strict';

    FileDownloadService.$inject = [
        '$q',
        '$http',
        '$window',
        'growl',
        'apiUrlPrefix',
        'apiUrlPort'
    ];

    function FileDownloadService($q, $http, $window, growl, apiUrlPrefix, apiUrlPort) {
        var apiServerUrl = apiUrlPrefix + (apiUrlPort ? ':' + apiUrlPort : '');
        var fileApiUrl = apiServerUrl + '/api/files';
        var downloadErrorMessage = 'Your file could not be downloaded.';
        var zipDownloadErrorMessage = 'One or more of your files could not be downloaded. Please refresh your page.';

        var service = {
            generate: getDownloadToken,
            download: downloadFile,
            downloadZip: downloadZip,
            getUrl: getDownloadUrl
        };

        function downloadZip(firmId, fileIds) {
            return getZipDownloadToken(fileIds)
                .then(function (token) {
                    $window.open(fileApiUrl + '/download-zip/' + firmId + '/' + token, '_self');
                }, function (reason) {
                    // TODO Need to figure out how to generally return errors everywhere!
                    var message = zipDownloadErrorMessage;
                    if (reason.indexOf('size-exceeded:') === 0) {
                        message = reason.substr(14);
                    }
                    growl.error(message);
                });
        }

        function getDownloadToken(fileId) {
            return $http.post(fileApiUrl + '/generate-download-token/' + fileId)
                .then(function (response) {
                    return response.data;
                });
        }

        function getZipDownloadToken(fileIds) {
            return $http.post(fileApiUrl + '/generate-zip-download-token', fileIds)
                .then(function (response) {
                    return response.data;
                }, function (response) {
                    if (response.status === 400) {
                        if (response.data.message.indexOf('size-exceeded:') === 0) {
                            return $q.reject(response.data.message);
                        }
                        if (response.data.message.indexOf('file-missing:') === 0) {
                            return $q.reject(response.data.message);
                        }
                    }
                    return $q.reject('Unknown Error');
                });
        }

        function downloadFile(firmId, fileId) {
            return getDownloadToken(fileId)
                .then(function (token) {
                    $window.open(fileApiUrl + '/' + firmId + '/' + token, '_self');
                }, function () {
                    growl.error(downloadErrorMessage);
                });
        }

        function getDownloadUrl(firmId, fileId) {
            return '/' + firmId + '/downloadFile/' + fileId;
        }

        return service;
    }

    module.exports = FileDownloadService;
})();